/**
 * Property-Tiles-and-Filters Component
 */

import { App } from '~/app';

import { defineAsyncComponent } from 'vue';
import { getMainEnquiryForm } from '../form-and-content/modal-form/modal-form';

import { scrollTo } from '../../../framework/scripts/utils/scroll';
export default (app: App) => {
	app.logger.debug('[Stockland FE] Initialise Stockland Property-Tiles-and-Filters Component');
	app.vueApp.component(
		'property-tiles-and-filters',
		defineAsyncComponent(async () => import('./PropertyTilesAndFilters.vue'))
	);
	app.vueApp.component(
		'property-listing',
		defineAsyncComponent(async () => import('./PropertyListing.vue'))
	);
	app.vueApp.component(
		'property-filter',
		defineAsyncComponent(async () => import('./PropertyFilters.vue'))
	);
	const listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]> = [];

	app.afterMount
		.then(() => {
			mountPropertyTilesAndFilters(listeners);
		})
		.catch((error) => {
			throw new Error('[Stockland FE] Unable to register Stockland Property Tiles', error);
		});

	return function destroyPropertyTilesAndFilters() {
		unMountPropertyTilesAndFilters(listeners);

		app.logger.debug('[DXA] Property Tiles destroyed');
	};
};
function mountPropertyTilesAndFilters(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>,
	root: HTMLElement | null = null
) {
	let rootNode: Document | HTMLElement = document;
	if (root) rootNode = root;

	const propertyTilesAndFilters = rootNode.querySelector('.property-tiles-and-filters');
	if (propertyTilesAndFilters) {
		const findOutMoreButton = propertyTilesAndFilters.querySelector('.find-out-more-button');

		if (findOutMoreButton) {
			findOutMoreButton.addEventListener('click', () => {
				const takeoverCallout = rootNode.querySelector<HTMLElement>('.takeover-callout');
				if (takeoverCallout) {
					scrollTo(takeoverCallout);
					const takeoverCalloutButton =
						takeoverCallout.querySelector<HTMLButtonElement>('.takeover-callout-button');
					if (takeoverCalloutButton) {
						takeoverCalloutButton.click();
					}
				} else {
					const enquiryButton = rootNode.querySelector<HTMLButtonElement>('.ribbon-bar-enquire-button');
					if (enquiryButton) {
						enquiryButton.click();
					}
				}
			});
		}
	}
}

export function unMountPropertyTilesAndFilters(
	listeners: Array<[Element | Window | Document, string, EventListenerOrEventListenerObject]>
) {
	for (const [element, event, listener] of listeners) {
		element.removeEventListener(event, listener);
	}
}
